module.exports = __webpack_public_path__ + "img/fincor_black1.22a4d752.jpg";